import React from 'react';
import PropTypes from 'prop-types';

import {labels} from '../../../../util/utils';
import {assertionOrder} from '../../../../util/uiconstants';

import {default as nameConfig} from './columns/Name';
import {default as assertionConfig} from './columns/Assertion';

import CustomTable from '../../../CoreWrappers/CustomTable';

const RelatedAccountsToRiskTable = ({id, data, className, isPrimary = false}) => {
	const columnStrings = ['name', ...assertionOrder];

	const columns = columnStrings.map((item) => {
		if (item === 'name')
			return nameConfig('nameColumn', isPrimary ? labels.primaryTeamAccountName : labels.componentTeamAccountName);

		return assertionConfig(`assertion_${item}_column`, item);
	});

	const props = {
		id,
		className,
		data,
		columns,
		defaultColumnSort: 'accountName'
	};

	return (
		<div className={className}>
			<CustomTable {...props} />
		</div>
	);
};

RelatedAccountsToRiskTable.propTypes = {
	id: PropTypes.string,
	data: PropTypes.arrayOf(PropTypes.shape({id: PropTypes.string})),
	isPrimary: PropTypes.bool
};

export default RelatedAccountsToRiskTable;
